export const bindTweaks = (): void => {
  const root = document.documentElement;
  bindGroup(root, "visual", "crt");
  bindGroup(root, "camera", "steady");
  bindGroup(root, "audio", "on");
};

type TweakGroup = "visual" | "camera" | "audio";

const bindGroup = (root: HTMLElement, group: TweakGroup, fallback: string): void => {
  root.dataset[group] ??= fallback;
  for (const button of document.querySelectorAll<HTMLButtonElement>(`[data-${group}]`)) {
    button.classList.toggle("active", button.dataset[group] === root.dataset[group]);
    button.addEventListener("click", () => {
      root.dataset[group] = button.dataset[group] ?? fallback;
      updateGroup(group, root.dataset[group] ?? fallback);
    });
  }
};

const updateGroup = (group: TweakGroup, value: string): void => {
  for (const button of document.querySelectorAll<HTMLButtonElement>(`[data-${group}]`)) {
    button.classList.toggle("active", button.dataset[group] === value);
  }
};
